<template>
    <header id="header" class="header">
        <div class="header-inner container-login">
        <div class="container">
            <div id="logo"> <router-link to="/"><span class="logo-default"><img src="../../assets/images/main_logo.png"></span><span class="logo-dark"><img src="images/main_logo.png"></span></router-link> </div>
            <div class="header-extras">
            <ul>
                <li v-if="currentRouteName != 'Index'">
                    <h3 class="gca-title mr-3 mt-5">QUIERO DESTACAR</h3>
                </li>
                <li v-if="currentRouteName != 'Index'">
                    <router-link :to="`detalle-producto/${idProducto}`" class="btn btn-primary btn-lg">COMPRAR AHORA</router-link>
                </li>
            </ul>
            </div>
            <div id="mainMenu-trigger"> <a class="lines-button x"><span class="lines"></span></a> </div>
            <div id="mainMenu" class="menu-center">
            <!-- <div class="container">
                <nav>
                <ul>
                    <li>
                    <a href="#">Certificaciones</a>
                        <ul class="dropdown-menu">
                        <li><router-link to="/adobe">Adobe Certified Professional</router-link></li>
                        <li><router-link to="/autodesk">Autodesk Certified User</router-link></li>
                        <li><router-link to="/csb">Communication Skills for Business</router-link></li>
                        <li><router-link to="/esb">Entrepreneurship & Small Business</router-link></li>
                        <li><router-link to="/ic3">IC3 Digital Literacy</router-link> </li>
                        <li><router-link to="/its">Information Technology Specialist</router-link></li>
                                                <li class="dropdown-submenu"><a href="#">Microsoft Certifications</a>
                            <ul class="dropdown-menu">
                            <li><router-link to="/mos">Microsoft Office Specialist</router-link></li>
                            <li><router-link to="/mce">Microsoft Certified Educator Specialist</router-link></li>
                                                        <li><a href="gca-mcf.html">Microsoft Certified Fundamentals</a></li>
                            </ul>
                        </li>
                        <li><router-link to="/swift">App Development with Swift</router-link></li>
                        <li><router-link to="/unity">Unity Certified User</router-link></li>
                        <li><router-link to="/pmi">Project Management Institute</router-link></li>
                        <li><router-link to="/cisco">Cisco Certified Support Technician</router-link></li>                        
                                            </ul>
                                    </li>
                    
                    <li><a href="#">Precios</a></li>
                    
                </ul>
                </nav>
            </div> -->
            </div>
        </div>
        </div>
    </header>
</template>

<script>

export default {
    data() {
        return {
            idProducto: 0
        }
    },
    mounted() {

        if(this.$route.path == '/mos')
            this.idProducto = 1
        if(this.$route.path == '/adobe')
            this.idProducto = 2
        if(this.$route.path == '/autodesk')
            this.idProducto = 3
        if(this.$route.path == '/csb')
            this.idProducto = 4
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    }
}
</script>
